export default __webpack_public_path__ + "static/media/pd8.49333430.jpg";